import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

export default function CreateHau() {
  const title = "Assign Hub To Admin";
  const [hubs, setHubs] = useState([]);
  const [users, setUsers] = useState([]);
  const [formData, setFormData] = useState({
    hubId: [], // Corrected initialization
    id_user: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const onChangeHandler = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (formData.hubId.length === 0) {
      newErrors.hubId = "At least one hub is required.";
    }
    if (!formData.id_user) {
      newErrors.id_user = "User is required.";
    }
    return newErrors;
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/admin/users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUsers(response.data.users);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };
    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchHubs = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/hubs`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setHubs(response.data.hubs);
        console.log("Hubs fetched:", response.data.hubs);
      } catch (error) {
        console.error("Error fetching hub:", error);
        setHubs([]);
      }
    };
    fetchHubs();
  }, []);

  const hubOptions = hubs.map((hub) => ({
    value: hub._id,
    label: hub.name,
  }));

  const handleHubChange = (selectedOptions) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      hubId: selectedOptions
        ? selectedOptions.map((option) => option.value)
        : [],
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/hubs/assign-admin`,
        {
          hubIds: formData.hubId, // Corrected key
          adminId: formData.id_user, // Corrected key
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response data:", response.data);

      if (response.status === 201) {
        navigate("/hau");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title} </div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="id_user">
                  <b>User *</b>
                </label>
                <select
                  name="id_user"
                  className="form-control"
                  value={formData.id_user}
                  onChange={onChangeHandler}
                >
                  <option value="">Select User</option>
                  {Array.isArray(users) &&
                    users.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.email}
                      </option>
                    ))}
                </select>
                {errors.id_user && (
                  <p className="text-danger">{errors.id_user}</p>
                )}
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="hub">
                  <b>Hub*</b>
                </label>
                <Select
                  name="hubId"
                  options={hubOptions}
                  onChange={handleHubChange}
                  value={hubOptions.filter((option) =>
                    formData.hubId.includes(option.value)
                  )}
                  isMulti
                  isClearable
                  placeholder="Select Hubs"
                  className="basic-single"
                  classNamePrefix="select"
                />
                {errors.hubId && <p className="text-danger">{errors.hubId}</p>}
              </div>

              <div className="col-md-6 mt-3"></div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Assign
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
